
jQuery(document).ready(function ($)
{
	const $featPropPagination = $('.swiper-pagination--featured-property')

	// partials/featured-property.php
	const swiper1 = new Swiper('.swiper-featured-property', {
		loop: true,
		effect: 'fade',
		fadeEffect: { crossFade: true },
		autoplay: { delay: 5000 },
		pagination: {
			el: '.swiper-pagination--featured-property',
			clickable: true,
		},
		autoHeight: true,
		// on: {
		// 	init: function () {
		// 		console.log('swiper initialized');
		// 		$featPropPagination.addClass( 'is-ready' );
		// 	},
		// },
	});


	// includes/properties-slider.php
	const swiper2 = new Swiper('.swiper-properties', {
		loop: true,
		// pagination: { el: '.swiper-pagination' },
		navigation: {
			nextEl: '[data-slider-next]',
			prevEl: '[data-slider-prev]',
		},
		slidesPerView: 3,
		spaceBetween: 25,
		breakpoints: {
			320: { slidesPerView: 1 },
			480: { slidesPerView: 1 },
			640: { slidesPerView: 2 },
			768: { slidesPerView: 3 }
		}
	});


	// partials/journal.php
	const swiper3 = new Swiper('.swiper-journal-videos', {
		loop: false,
		// pagination: { el: '.swiper-pagination' },
		navigation: {
			nextEl: '[data-slider-next]',
			prevEl: '[data-slider-prev]',
		},
		slidesPerView: 3,
		spaceBetween: 25,
		breakpoints: {
			320: { slidesPerView: 1 },
			480: { slidesPerView: 1 },
			640: { slidesPerView: 2 },
			768: { slidesPerView: 4 }
		}
	});

});
